import gsap, { Power2 } from "gsap";
import userLockScroll from "./functions/userLockScroll";
import fadeEffect from "./functions/FadeEffect";
import translate from "./functions/translate";
import simpleValidate from "./functions/simpleValidate";
import linkResolver from "../linkResolver";
import { HoldAllScrollPage, HoldScrollPage } from "./functions/HoldScrollPage";

async function scrollToPos(scrollTop, duration = 1, block = "body, html") {
  if (window.lenis) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(), duration * 1000);
      window.lenis.scrollTo(scrollTop, {
        duration: duration * 2,
        force: true,
      });
    });
  } else {
    return new Promise((resolve) => {
      gsap.to(block, {
        scrollTop: scrollTop,
        ease: Power2.easeInOut,
        duration,
        onComplete: resolve,
      });
    });
  }
}
const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("scrollToPos", scrollToPos);
  nuxtApp.vueApp.directive("lock-scroll", userLockScroll);
  nuxtApp.provide("translate", translate);
  nuxtApp.provide("simpleValidate", simpleValidate);
  nuxtApp.provide("linkResolver", linkResolver);
  nuxtApp.provide("capitalize", capitalize);
  nuxtApp.provide("HoldAllScrollPage", HoldAllScrollPage);
  nuxtApp.provide("HoldScrollPage", HoldScrollPage);
  // nuxtApp.provide("FadeEffect", FadeEffect);
  nuxtApp.vueApp.directive("fade-effect", fadeEffect);
});
